export const RESULT_SCHEMA = "exercise-result/v1"

const ENVELOPE_KEYS = ["schema", "id", "type", "title", "level", "source", "config", "items"]
const RESULT_KEYS = ["schema", "exercise_id", "completed_at", "items", "score"]
const ITEM_RESULT_KEYS = ["id", "outcome", "ms", "attempts", "picked"]

export function extraKeys(source, knownKeys) {
  if (!source || typeof source !== "object" || Array.isArray(source)) return {}

  return Object.keys(source).reduce((carry, key) => {
    if (knownKeys.includes(key)) return carry
    carry[key] = source[key]
    return carry
  }, {})
}

export function envelopeExtras(exercise) {
  return extraKeys(exercise, ENVELOPE_KEYS)
}

export function collapseAttempts(attempts) {
  const order = []
  const byId = new Map()

  attempts.forEach((attempt) => {
    const id = attempt.id
    if (!byId.has(id)) {
      order.push(id)
      byId.set(id, { id, outcome: attempt.outcome, ms: 0, attempts: 0, extra: {} })
    }

    const record = byId.get(id)
    record.outcome = attempt.outcome
    record.ms += Number.isFinite(attempt.ms) ? Math.max(0, Math.round(attempt.ms)) : 0
    record.attempts += 1
    if (attempt.picked !== undefined) record.picked = attempt.picked
    if (attempt.extra) record.extra = attempt.extra
  })

  return order.map((id) => byId.get(id))
}

export function buildItemResult(record) {
  const item = { id: record.id, outcome: record.outcome, ms: record.ms }
  if (record.picked !== undefined) item.picked = record.picked
  if (record.attempts > 1) item.attempts = record.attempts

  Object.entries(extraKeys(record.extra, ITEM_RESULT_KEYS)).forEach(([key, value]) => {
    item[key] = value
  })

  return item
}

export function buildResult(exercise, attempts, { now, correctOutcomes = [] } = {}) {
  const clock = typeof now === "function" ? now : Date.now
  const records = collapseAttempts(Array.isArray(attempts) ? attempts : [])
  const items = records.map(buildItemResult)
  const correct = records.filter((record) => correctOutcomes.includes(record.outcome)).length

  const result = {
    schema: RESULT_SCHEMA,
    exercise_id: typeof exercise?.id === "string" ? exercise.id : null,
    completed_at: new Date(clock()).toISOString(),
    items,
    score: { correct, total: records.length }
  }

  Object.entries(envelopeExtras(exercise)).forEach(([key, value]) => {
    if (RESULT_KEYS.includes(key)) return
    result[key] = value
  })

  return result
}
